import { useEffect } from 'react';
import { NEWSLETTER_MESSAGE } from '../constants/newsletterMessage';
import { debouncedHandleEmailValidation } from '@App/common/utils/debouncedHandleEmailValidation';
const createMessageElement = (message, isSuccess = false) => {
  const element = document.createElement('p');
  element.textContent = message;
  element.classList.add('message');
  element.classList.add(isSuccess ? 'success' : 'error');
  return element;
};
const updateButtonState = (node, isLoading, isDisabled) => {
  const button = node.querySelector('button');
  button.classList.toggle('loading', isLoading);
  button.disabled = isDisabled;
};
const updateInputErrorState = (node, isError) => {
  const input = node.querySelector('input');
  input.classList.toggle('invalid', isError);
};
const handleEmailChange = async e => {
  var _formNode$querySelect;
  const formNode = e.target.closest('form');
  const isValid = await debouncedHandleEmailValidation(e);
  (_formNode$querySelect = formNode.querySelector('.message')) === null || _formNode$querySelect === void 0 ? void 0 : _formNode$querySelect.remove();
  updateInputErrorState(formNode, !isValid);
  updateButtonState(formNode, false, !isValid);
  if (!isValid) {
    formNode.appendChild(createMessageElement(NEWSLETTER_MESSAGE.invalidEmail));
  }
};
const handleSubmit = async (onSubscribe, event) => {
  event.preventDefault();
  const formNode = event.target;
  const email = formNode.querySelector('input').value;
  if (email.length === 0) {
    var _formNode$querySelect2;
    (_formNode$querySelect2 = formNode.querySelector('.message')) === null || _formNode$querySelect2 === void 0 ? void 0 : _formNode$querySelect2.remove();
    formNode.appendChild(createMessageElement(NEWSLETTER_MESSAGE.emptyEmail));
  } else {
    var _formNode$querySelect3;
    updateButtonState(formNode, true, true);
    const response = await onSubscribe(email);
    (_formNode$querySelect3 = formNode.querySelector('.message')) === null || _formNode$querySelect3 === void 0 ? void 0 : _formNode$querySelect3.remove();
    updateInputErrorState(formNode, false);
    updateButtonState(formNode, false, false);
    if (response.isEmailTaken) {
      formNode.appendChild(createMessageElement(NEWSLETTER_MESSAGE.emailIsTaken));
      updateInputErrorState(formNode, true);
      updateButtonState(formNode, false, true);
    }
    if (response.isSubscribed) {
      formNode.appendChild(createMessageElement(NEWSLETTER_MESSAGE.subscribed, true));
    }
  }
};
const useArticleNewsletterForms = onSubscribe => {
  useEffect(() => {
    const formNodes = document.querySelectorAll('.newsletter form');
    const formArray = [].slice.call(formNodes);
    formArray.forEach(node => {
      node.addEventListener('input', handleEmailChange.bind(this));
      node.addEventListener('submit', handleSubmit.bind(this, onSubscribe));
    });
    return () => {
      formArray.forEach(node => {
        node.removeEventListener('input', handleEmailChange.bind(this));
        node.removeEventListener('submit', handleSubmit.bind(this, onSubscribe));
      });
    };
  }, []);
};
export default useArticleNewsletterForms;